import { createActions } from 'redux-actions';
import { Pagination } from '@models/Pagination';

import { InsurancePolicy } from '@models/InsurancePolicy';
import { InsurancePolicyUser } from '@models/InsurancePolicyUser';
import { GetAllInsurancePolicyParams } from '@apis/InsurancePolicyApi';
import { SearchInsurancePolicyUserParams } from '@apis/InsurancePolicyUserApi';

export type State = {
  insurancePolicies?: InsurancePolicy[] | null;
  insurancePolicyUsers?: InsurancePolicyUser[] | null;
  pagination?: Pagination;
  showBenefitScheduleDialog: boolean;
  isLoading: boolean;
};

export type InsurancePoliciesFetchPayload = GetAllInsurancePolicyParams;
export type InsurancePolicyUsersFetchPayload = SearchInsurancePolicyUserParams;

export type StateUpdatePayload = Partial<State>;

export const {
  insurancePoliciesFetch,
  insurancePolicyUsersFetch,
  stateUpdate,
} = createActions(
  'INSURANCE_POLICIES_FETCH',
  'INSURANCE_POLICY_USERS_FETCH',
  'STATE_UPDATE',
  {
    prefix: 'SEARCH_INSURANCE_POLICY_USER_PAGE',
  },
);
